<template>
  <div>
    <b-modal
      id="modalImportarSisc"
      title="Importar Grupos do SISC"
      centered
      no-close-on-backdrop
      cancel-title="Cancelar"
      hide-footer
    >
      <form @submit.prevent="submitImportar" ref="submitImportar">
        <div class="row">
          <form-file   
            label="Enviar arquivo tratado no formato CSV"
            @submit="submitFile"
            btn-text="Iniciar"
            :progress="progressCompleted"
            ajuda="O arquivo deverá ser convertido antes de ser enviado assista o <a href='#'>vídeo tutorial</a> e veja como fazer."
            textInput="Localizar arquivo"
          />
        </div>
        <div class="row" v-if="loadSubmit == false">
          <label class="d-block font-weight-bold pl-3">Selecione o técnico responsável</label>
          <form-select
                    v-model="unidade_id"
                    label="Unidade"
                    :itens="unidades"
                    grid="6"
                    @selected="searchTecnicos"
                    :loading="loadUnidades"
                />

                <form-select
                   v-model="tecnico_id"
                    label="Técnico Responsável"
                    :loading="loadingTecnicos"
                    :itens="tecnicos"
                    grid="6"
                    :required="true"
                />
        </div>
        
  
        <div class="row pt-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "ImportarSisc",
  data() {
    return {
      file: null,
      progressCompleted: 0,
      tecnicos: [],
      unidades: [],
      unidade_id: null,
      tecnico_id: null,
      loadUnidades:false  , 
      loadingTecnicos:false  , 
      loadSubmit:false
     };
  },
  mounted(){
    this.getUnidades()
  },
  methods: {
    submitFile(file) {
      var array = file.name.split(".");
      var extension = array[array.length - 1];
      if (extension.toLowerCase() == "csv") {
        this.file = file;
      } else {
        swal.fire({
          icon: "error",
          title: "Formato invalido!",
          text: "Apenas arquivos do .txt e .zip são aceitos.",
          showConfirmButton: false,
          timer: 4000,
        });
      }
    },
    submitImportar() {
      let formData = new FormData();
      this.loadSubmit = true;
      formData.append("file", this.file);
      formData.append("tecnico_id", this.tecnico_id);
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(`api/dashboard/importar/scfvsisc`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          swal.fire({
            icon: "success",
            title: "Dados importados com sucesso!",
            html: response.data.data.message,
            showConfirmButton: false,
            timer: 4000,
          });
          this.$bvModal.hide("modalImportarSisc");
          this.$parent.getItens();
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
          this.loadSubmit = false;
          this.unidade_id = null;
          this.tecnico_id = null;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "Algo de errado aconteceu!<br>" + error,
            icon: "error",
          });
        });
    },
    getUnidades() {
            const ue = "";
            this.loadUnidades = true;
            axios
                .get(`api/dashboard/unidades/get/externas/${ue}`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => {
                    this.loadUnidades = false;
                });
        },
    searchTecnicos() {
            this.tecnicos = [];
            this.loadingTecnicos = true;

            axios
                .get(
                    `api/dashboard/tecnicos/get/externos/${this.unidade_id}`
                )
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadingTecnicos = false;
                });
        },
  },
};
</script>
